import { render, staticRenderFns } from "./clientView.vue?vue&type=template&id=705728b9&scoped=true&"
import script from "./clientView.vue?vue&type=script&lang=js&"
export * from "./clientView.vue?vue&type=script&lang=js&"
import style0 from "./clientView.vue?vue&type=style&index=0&id=705728b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705728b9",
  null
  
)

export default component.exports